<template>
    <div>
        <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown" data-target="#myModal">
            <i class="fa fa-cog"></i>
        </button>

        <div class="dropdown-menu col-lg-4 col-md-4 col-xs-12" >
            <kt-row class="form-control mb-2" style="text-align: center">
                <kt-col lg="12" md="12" xs="12">
                    <span>
                     {{ 'old sheba : ' + this.row.rejection_reason.old_sheba.number }}
                </span>
                </kt-col>

            </kt-row>
            <kt-row class="form-control mb-2" style="text-align: center">
                <kt-col lg="12" md="12" xs="12">
                    <span>
                     {{ 'new sheba : ' + this.row.rejection_reason.new_sheba.number }}
                </span>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="6" md="6" xs="6" style="text-align: center">
                    <kt-button
                            class="m-2 "
                            size="md"
                            variant="primary"
                            type="button"
                            :id="'confirm_btn' + this.row.id"
                            @click="changeRequestStatus(shRequestStatus.PENDING, 'confirm_btn')"
                            style="text-align: center"
                    >
                        {{ $t('btn.confirm_request') }}
                    </kt-button>
                </kt-col>
                <kt-col lg="6" md="6" xs="6" style="text-align: center">
                    <kt-button
                            class="m-2"
                            size="md"
                            variant="danger"
                            type="button"
                            :id="'reject_btn' + this.row.id"
                            @click="changeRequestStatus(shRequestStatus.FINAL_REJECT, 'reject_btn')"

                    >
                        {{ $t('btn.reject_request') }}
                    </kt-button>
                </kt-col>
            </kt-row>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import $ from 'jquery'
    import { i18n } from '@/plugins/i18n'
    import { shRequestStatus } from '@/constants/shaparakRequestStatus'
    import { shaparakService } from "@/common/api.service"
    import toastr from "toastr";
    import { KTApp } from '@/plugins/core/app'

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            },
            store: {
                required: true
            }
        },
        data() {
            return {
                shRequestStatus: shRequestStatus
            }
        },
        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            },
        },
        methods: {
            changeRequestStatus(status, btn_id) {
                let btn = $('#' + btn_id + this.row.id);

                KTApp.progress(btn)

                let params = {
                    status: status,
                    hashid: this.row.id,
                }
                shaparakService.changeCreatedRequestStatus(params).then(response => {
                    this.toastr.success(response.data.message)
                    KTApp.unprogress(btn)
                    this.datatable.reload()
                    this.store.dispatch('badgeCounter/countData')
                }).catch(({response}) => {
                    this.toastr.fail()
                    KTApp.unprogress(btn)
                })
            }
        }
    })
</script>

<style>

</style>